module.exports = __webpack_public_path__ + "img/23.1fd094a7.jpg";